import { User } from '@/app-modules/store/modules/user';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { EncodedChatStatusUsers } from '@/app-modules/store/modules/chat-status-user-map';
import { TogglesStore } from '@/app-modules/store/modules/toggles';

type SaveableObject = User | UserPreferences | EncodedChatStatusUsers | TogglesStore;

enum SaveableTypeStoreLocation {
  LocalStorage = 0,
  SessionStorage
}

interface ISaveableTypeDescriptor {
  readonly name: string;
  readonly type: new() => SaveableObject;
  readonly storeLocation: SaveableTypeStoreLocation;
}

const SaveableTypes: ISaveableTypeDescriptor[] = [
  {
    name: '',
    type: User,
    storeLocation: SaveableTypeStoreLocation.SessionStorage
  },
  {
    name: 'c',
    type: UserPreferences,
    storeLocation: SaveableTypeStoreLocation.LocalStorage
  },
  {
    name: 'm',
    type: EncodedChatStatusUsers,
    storeLocation: SaveableTypeStoreLocation.LocalStorage
  },
  {
    name: 's',
    type: TogglesStore,
    storeLocation: SaveableTypeStoreLocation.LocalStorage
  }
];

function findSaveableTypeDescriptor(constructorFunc: new () => SaveableObject): ISaveableTypeDescriptor {
  return SaveableTypes.find((savableType) => savableType.type === constructorFunc);
}

export { SaveableTypeStoreLocation, ISaveableTypeDescriptor, SaveableTypes, SaveableObject, findSaveableTypeDescriptor };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/store/modules/index.ts